const roles = {
    unique_notific: "",
    username: "",
    Authorization: "",
    role: "",
    name: "",
    snowtoken: "",
    emailid: "",
    isAuthenticate: "",
    isReady: "",
    ooc_user_role: "",
    userRole: "",
    JWT: "",
    ztToken: "",
    
    //role Token (cryptographically signed, verified by backend)
    roleToken: null,           // Full signed role token sent in x-role-token header
    roleTokenPayload: {        // Decoded role token payload for UI use
        cq: null,              // CQ role
        ooc: null,             // OOC role
        retpak: null,          // RetPak role
        email: null,           // Users email from token
        iat: null,             // Issued at timestamp
        exp: null              // Expiration timestamp
    }
};
 
const updateRoles = (newValues) => {
    for (const key in newValues) {
        if (roles.hasOwnProperty(key)) {
            roles[key] = newValues[key];
        }
    }
};
 
export { roles, updateRoles };